import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { Loader } from "../components/Loader";

export default function InterestsOnboarding() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [interests, setInterests] = useState(null);
  const [selected, setSelected] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api("/interests").then((d) => setInterests(d.filter((i) => !i.parent_id))).catch(() => setInterests([])); }, []);

  const toggle = (id) => setSelected((p) => {
    if (p.includes(id)) return p.filter((x) => x !== id);
    if (p.length >= 5) { toast.error("الحد الأقصى 5 قوائم"); return p; }
    return [...p, id];
  });

  const save = async () => {
    if (selected.length === 0) return toast.error("اختر قائمة واحدة على الأقل");
    setBusy(true);
    try { await api("/auth/profile", { method: "PUT", body: JSON.stringify({ selected_interests: selected, onboarded: true }) }); await refresh(); navigate("/"); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  const skip = async () => {
    setBusy(true);
    try { await api("/auth/profile", { method: "PUT", body: JSON.stringify({ onboarded: true }) }); await refresh(); navigate("/"); } catch {} finally { setBusy(false); }
  };

  if (!interests) return <Loader />;

  return (
    <div className="min-h-screen bg-[#FAFBFF] px-4 py-10" dir="rtl">
      <div className="max-w-lg mx-auto animate-fade-in-up">
        <h1 className="text-2xl font-black text-[#161629] text-center">ما الذي يهمك؟</h1>
        <p className="text-[#6B7280] text-center mt-1">اختر حتى 5 قوائم لتخصيص تجربتك</p>
        <div className="flex flex-wrap gap-2 justify-center mt-6">
          {interests.map((i) => (
            <button key={i.interest_id} data-testid={`onb-${i.interest_id}`} onClick={() => toggle(i.interest_id)} className={`px-4 py-2.5 rounded-full border font-bold ${selected.includes(i.interest_id) ? "bg-[#FF3D5A] border-[#FF3D5A] text-white" : "bg-white border-[#E8EAF2]"}`}>{i.name}</button>
          ))}
        </div>
        <button data-testid="onb-save" disabled={busy} onClick={save} className="w-full py-4 rounded-2xl bg-[#FF3D5A] text-white font-black mt-8 disabled:opacity-60">حفظ ومتابعة</button>
        <button data-testid="onb-skip" onClick={skip} className="w-full py-3 text-[#6B7280] font-bold mt-2">تخطي</button>
      </div>
    </div>
  );
}
